import { Action } from '@ngrx/store';
import { UserPermissions } from '../../types/user-permissions.types';

export enum UserPermissionsActionTypes {
  Load = '[UserPermissions] Load',
  LoadSuccess = '[UserPermissions] Load Success',
  LoadFail = '[UserPermissions] Load Fail',
  SkipLoad = '[UserPermissions] Skip Load'
}

export class LoadUserPermissionsSkip implements Action {
  public readonly type = UserPermissionsActionTypes.SkipLoad;
}

export class LoadUserPermissions implements Action {
  public readonly type = UserPermissionsActionTypes.Load;
}

export class LoadUserPermissionsSuccess implements Action {
  public readonly type = UserPermissionsActionTypes.LoadSuccess;

  constructor(public payload: UserPermissions) {}
}

export class LoadUserPermissionsFail implements Action {
  public readonly type = UserPermissionsActionTypes.LoadFail;

  constructor(public payload: string) {}
}

export type UserPermissionsActionsUnion =
  | LoadUserPermissions
  | LoadUserPermissionsSuccess
  | LoadUserPermissionsFail
  | LoadUserPermissionsSkip;
